function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Link } from '../../index';
var MenuDropdown = function MenuDropdown(props) {
  var dropdownMenu = props.dropdownMenu,
    isLoggedIn = props.isLoggedIn,
    daasLink = props.daasLink,
    logoutUrl = props.logoutUrl;
  if (!dropdownMenu) return null;
  var _useState = useState(dropdownMenu.type),
    _useState2 = _slicedToArray(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];
  function checkEnv(host) {
    if (host === 'stage.telia.no' || host === 'at-min-side.telia.no') return 'https://stage.telia.no';
    if (host === 'pt.stage.telia.no') return 'https://pt.stage.telia.no/min-side/';
    return false;
  }
  var stageEnv = checkEnv(window.location.host);
  return /*#__PURE__*/React.createElement("div", {
    className: "menu__dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "menu__dropdown--button"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button--link ".concat(type === 'B2C' ? 'button--active' : ''),
    onClick: function onClick() {
      return setType('B2C');
    }
  }, "Privat"), /*#__PURE__*/React.createElement("button", {
    className: "button button--link ".concat(type === 'B2B' ? 'button--active' : ''),
    onClick: function onClick() {
      return setType('B2B');
    }
  }, "Bedrift")), type === 'B2C' && /*#__PURE__*/React.createElement("div", {
    className: "menu__dropdown--links"
  }, /*#__PURE__*/React.createElement(Link, {
    type: "bubble-link",
    href: stageEnv ? "".concat(stageEnv, "/min-side/") : 'https://www.telia.no/minside/hjem',
    icon: "home",
    inverted: dropdownMenu.channel !== 'mobil'
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '.5rem'
    }
  }, "Hjem"))), type === 'B2B' && /*#__PURE__*/React.createElement("div", {
    className: "menu__dropdown--links"
  }, /*#__PURE__*/React.createElement(Link, {
    type: "bubble-link",
    href: "https://minbedrift.telia.no/",
    icon: "mobile",
    inverted: dropdownMenu.channel !== 'min-bedrift'
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '.5rem'
    }
  }, "Min Bedrift")), /*#__PURE__*/React.createElement(Link, {
    type: "bubble-link",
    href: "https://minportal.telia.no/",
    icon: "wireless",
    inverted: dropdownMenu.channel !== 'min-portal'
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '.5rem'
    }
  }, "Min Portal")), /*#__PURE__*/React.createElement(Link, {
    type: "bubble-link",
    href: "https://sb.telia.no/bn/login",
    icon: "product-bedriftsnett",
    inverted: dropdownMenu.channel !== 'bedriftsnett'
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '.5rem'
    }
  }, "Bedriftsnett")), daasLink && /*#__PURE__*/React.createElement(Link, {
    type: "bubble-link",
    href: daasLink.url,
    icon: "mobile",
    inverted: dropdownMenu.channel !== 'min-bedrift'
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '.5rem'
    }
  }, daasLink.text)), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '1rem'
    }
  }), /*#__PURE__*/React.createElement(Link, {
    href: "https://www.telia.no/bedrift/info/",
    icon: "list-view",
    iconPosition: "before",
    iconColor: "black",
    style: {
      marginLeft: '2.25rem'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      paddingLeft: '.8rem'
    }
  }, "Andre portaler"))), /*#__PURE__*/React.createElement("div", {
    className: "menu__dropdown--logout"
  }, !isLoggedIn && /*#__PURE__*/React.createElement("p", {
    className: "menu__dropdown--logout--not-logged-in"
  }, "Logg ut"), isLoggedIn && /*#__PURE__*/React.createElement(Link, {
    href: logoutUrl !== null && logoutUrl !== void 0 ? logoutUrl : 'https://www.telia.no/logout/'
  }, "Logg ut")));
};
export default MenuDropdown;